import React, { createContext, useState } from "react";
import { useMemo } from "react";
import { GetJobs } from "../../api/api";

export const MinerPageContext = createContext({
  tableGroup: {},
  setTableGroup: (tableGroup) => {},
  detailGroup: {},
  setDetailGroup: (detailGroup) => {},
  siteSelectedName: "",
  setSiteSelectedName: (siteSelectedName) => {},
  groupSelectedName: "",
  setGroupSelectedName: (groupSelectedName) => {},
  selectedSerials: [],
  setSelectedSerials: (selectedSerials) => {},
  selectedChassisSerials: [],
  setSelectedChassisSerials: (selectedChassisSerials) => {},
  untagMinersDialogOpen: false,
  setUntagMinersDialogOpen: (untagMinersDialogOpen) => {},
  groupFilters: {},
  setGroupFilters: (groupFilters) => {},
  MinerConfigurationModalOpen: false,
  setMinerConfigurationModalOpen: (
    MinerConfigurationModalOpen
  ) => {},
  whichMinerConfigurationForm: "",
  setWhichMinerConfigurationForm: (
    whichMinerConfigurationForm
  ) => {},
  customizationModalOpen: false,
  setCustomizationModalOpen: (customizationModalOpen) => {},
  customPowerModalOpen: false,
  setCustomPowerModalOpen: (customPowerModalOpen) => {},
  retuneModalOpen: false,
  setRetuneModalOpen: (retuneModalOpen) => {},
  setUpgradeModalOpen: (setUpgradeModalOpen) => {},
  upgradeModalOpen: false,
  jobs: [],
  setJobs: (jobs) => {},
  transferModalOpen: false,
  setTransferModalOpen: (transferModalOpen) => {},
  minerDeletionModalOpen: false,
  setMinerDeletionModalOpen: (minerDeletionModalOpen) => {},
  resetCurtailSchedulesModalOpen: false,
  setResetCurtailSchedulesModalOpen: (
    resetCurtailSchedulesModalOpen
  ) => {},
  reImageModalOpen: false,
  setReImageModalOpen: (
    reImageModalOpen
  ) => {},
  factoryResetModalOpen: false,
  setFactoryResetModalOpen: (factoryResetModalOpen) => {},
  restartModalOpen: false,
  setRestartModalOpen: (restartModalOpen) => {},
  ecoModalOpen: false,
  setEcoModalOpen: (ecoModalOpen) => {},
  turboModalOpen: false,
  setTurboModalOpen: (turboModalOpen) => {},
  poolsData: [],
  setPoolsData: (poolsData) => {},
  psuData: [],
  setPsuData: (psuData) => {},
  openPSUDialog: false,
  setOpenPSUDialog: (openPSUDialog) => {},
  fansData: [],
  setFansData: (fansData) => {},
  openFansDialog: false,
  setOpenFansDialog: (openFansDialog) => {},
  jobId: "",
  setJobId: (jobId) => {},
  stepperOpen: false,
  setStepperOpen: (stepperOpen) => {},
  fluxVisionTuning: true,
  setFluxVisionTuning: (fluxVisionTuning) => {},
  minerPageTagListSelectionTracker: "",
  setMinerPageTagListSelectionTracker: (
    minerPageTagListSelectionTracker
  ) => {},
});

export const MinerPageContextProvider = (props) => {
  const [tableGroup, setTableGroup] = useState({});
  const [detailGroup, setDetailGroup] = useState({});
  const [jobs, setJobs] = useState([]);
  const [siteSelectedName, setSiteSelectedName] =
    useState("");
  const [groupSelectedName, setGroupSelectedName] =
    useState("");
  const [selectedSerials, setSelectedSerials] = useState(
    []
  );
  const [selectedChassisSerials, setSelectedChassisSerials] = useState(
    []
  );
  const [untagMinersDialogOpen, setUntagMinersDialogOpen] =
    useState(false);
  const [groupFilters, setGroupFilters] = useState({});
  const [
    customizationModalOpen,
    setCustomizationModalOpen,
  ] = useState(false);
  const [
    MinerConfigurationModalOpen,
    setMinerConfigurationModalOpen,
  ] = useState(false);
  const [
    whichMinerConfigurationForm,
    setWhichMinerConfigurationForm,
  ] = useState("");
  const [customPowerModalOpen, setCustomPowerModalOpen] =
    useState(false);
  const [retuneModalOpen, setRetuneModalOpen] =
    useState(false);
  const [upgradeModalOpen, setUpgradeModalOpen] =
    useState(false);
  const [transferModalOpen, setTransferModalOpen] =
    useState(false);
  const [
    minerDeletionModalOpen,
    setMinerDeletionModalOpen,
  ] = useState(false);
  const [
    resetCurtailSchedulesModalOpen,
    setResetCurtailSchedulesModalOpen,
  ] = useState(false);
  const [
    reImageModalOpen,
    setReImageModalOpen,
  ] = useState(false);
  const [factoryResetModalOpen, setFactoryResetModalOpen] =
    useState(false);
  const [ecoModalOpen, setEcoModalOpen] = useState(false);
  const [turboModalOpen, setTurboModalOpen] =
    useState(false);
  const [restartModalOpen, setRestartModalOpen] =
    useState(false);
  const [poolsData, setPoolsData] = useState([]);
  const [psuData, setPsuData] = useState([]);
  const [fansData, setFansData] = useState([]);
  const [openPoolsDialog, setOpenPoolsDialog] =
    useState(false);
  const [openPSUDialog, setOpenPSUDialog] = useState(false);
  const [openFansDialog, setOpenFansDialog] =
    useState(false);
  const [jobId, setJobId] = useState("");
  const [stepperOpen, setStepperOpen] = useState(false);
  const [fluxVisionTuning, setFluxVisionTuning] =
    useState(true);
  const [minerCount, setMinerCount] = useState(null);
  const [
    minerPageTagListSelectionTracker,
    setMinerPageTagListSelectionTracker,
  ] = useState("");

  const contextValue = useMemo(() => {
    return {
      jobs,
      setJobs,
      tableGroup,
      setTableGroup,
      detailGroup,
      setDetailGroup,
      siteSelectedName,
      setSiteSelectedName,
      groupSelectedName,
      setGroupSelectedName,
      selectedSerials,
      setSelectedSerials,
      selectedChassisSerials,
      setSelectedChassisSerials,
      untagMinersDialogOpen,
      setUntagMinersDialogOpen,
      groupFilters,
      setGroupFilters,
      MinerConfigurationModalOpen,
      setMinerConfigurationModalOpen,
      whichMinerConfigurationForm,
      setWhichMinerConfigurationForm,
      customizationModalOpen,
      setCustomizationModalOpen,
      customPowerModalOpen,
      setCustomPowerModalOpen,
      retuneModalOpen,
      setRetuneModalOpen,
      upgradeModalOpen,
      setUpgradeModalOpen,
      transferModalOpen,
      setTransferModalOpen,
      minerDeletionModalOpen,
      setMinerDeletionModalOpen,
      factoryResetModalOpen,
      setFactoryResetModalOpen,
      resetCurtailSchedulesModalOpen,
      setResetCurtailSchedulesModalOpen,
      reImageModalOpen,
      setReImageModalOpen,
      ecoModalOpen,
      setEcoModalOpen,
      turboModalOpen,
      setTurboModalOpen,
      restartModalOpen,
      setRestartModalOpen,
      poolsData,
      setPoolsData,
      psuData,
      setPsuData,
      fansData,
      setFansData,
      openPoolsDialog,
      setOpenPoolsDialog,
      openPSUDialog,
      setOpenPSUDialog,
      openFansDialog,
      setOpenFansDialog,
      jobId,
      setJobId,
      stepperOpen,
      setStepperOpen,
      fluxVisionTuning,
      setFluxVisionTuning,
      minerCount,
      setMinerCount,
      minerPageTagListSelectionTracker,
      setMinerPageTagListSelectionTracker,
    };
  }, [
    jobs,
    setJobs,
    tableGroup,
    detailGroup,
    siteSelectedName,
    groupSelectedName,
    selectedSerials,
    selectedChassisSerials,
    untagMinersDialogOpen,
    setUntagMinersDialogOpen,
    groupFilters,
    setGroupFilters,
    MinerConfigurationModalOpen,
    setMinerConfigurationModalOpen,
    whichMinerConfigurationForm,
    setWhichMinerConfigurationForm,
    customizationModalOpen,
    setCustomizationModalOpen,
    customPowerModalOpen,
    setCustomPowerModalOpen,
    retuneModalOpen,
    setRetuneModalOpen,
    upgradeModalOpen,
    setUpgradeModalOpen,
    transferModalOpen,
    setTransferModalOpen,
    minerDeletionModalOpen,
    setMinerDeletionModalOpen,
    factoryResetModalOpen,
    setFactoryResetModalOpen,
    resetCurtailSchedulesModalOpen,
    setResetCurtailSchedulesModalOpen,
    reImageModalOpen,
    setReImageModalOpen,
    ecoModalOpen,
    setEcoModalOpen,
    turboModalOpen,
    setTurboModalOpen,
    restartModalOpen,
    setRestartModalOpen,
    poolsData,
    setPoolsData,
    psuData,
    setPsuData,
    fansData,
    setFansData,
    openPoolsDialog,
    setOpenPoolsDialog,
    openPSUDialog,
    setOpenPSUDialog,
    openFansDialog,
    setOpenFansDialog,
    jobId,
    setJobId,
    stepperOpen,
    setStepperOpen,
    fluxVisionTuning,
    setFluxVisionTuning,
    minerCount,
    setMinerCount,
    minerPageTagListSelectionTracker,
    setMinerPageTagListSelectionTracker,
  ]);

  return (
    <MinerPageContext.Provider value={contextValue}>
      {props.children}
    </MinerPageContext.Provider>
  );
};
